export default __webpack_public_path__ + "static/5-pick-date-bf9e9eb938300da07ed76f6a6fbbf7ac.png";